<template>
    <div>
        <div v-if="str" class="app-container">
            <div v-if="data && data.image" class="app-image">
                <img :src="data.image" />
            </div>
            <div v-if="data && data.name" v-html="data.name" class="app-title">
            </div>
            <div v-if="data && data.info" v-html="data.info" class="app-text">
            </div>
            <div v-if="data && data.urls && data.urls.length" class="app-videos">
                <div v-for="(video, index) in data.urls" :key="index">
                    <iframe width="100%" height="300" :src="video" frameborder="0" allowfullscreen></iframe>
                </div>
            </div>
            <div class="app-footer flex-center">
                <v-btn @click="back()" class="default">
                    {{ str['back'] }}
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>
import Utils from '../services/Utils'

export default {
    data() {
        return {
            str: Utils.getStrings(),
            data: window.cache && window.cache.content ? window.cache.content : null,
        }
    },
    beforeMount: function () {
        if (!this.data) {
            this.back()
        }
    },
    methods: {
        back: function () {
            this.$router.back()
        },
        onBackEvent: function () {
            const self = this
            this.$root.$on('app-back', function () {
                self.back()
            })
        },
        offBackEvent: function () {
            this.$root.$off('app-back')
        },
    },
    mounted () {
        this.onBackEvent()
    },
    beforeDestroy () {
      this.offBackEvent()
    }
}
</script>